import React from 'react'
import {
  TableRow,
  TableCell,
  Checkbox,
  IconButton,
  Tooltip,
} from '@material-ui/core'
import SaveAltFilled from 'Components/Icons/SaveAltFilled'
import { formatFileSize, formatDate } from './utils'

const SftpFileRow = ({
  file,
  canDownload,
  selected,
  onSelect,
  onDownloadFile,
  classes,
}) => {
  const ext =
    file.fileName && file.fileName.includes('.')
      ? file.fileName
          .split('.')
          .pop()
          .toUpperCase()
      : (file.format || '').toUpperCase()

  return (
    <TableRow key={file.key} hover>
      {canDownload && (
        <TableCell padding="checkbox">
          <Checkbox
            checked={selected.has(file.key)}
            onChange={() => onSelect(file.key)}
          />
        </TableCell>
      )}
      <TableCell>{file.fileName}</TableCell>
      <TableCell>{ext}</TableCell>
      <TableCell>{formatFileSize(file.size)}</TableCell>
      <TableCell>{file.ownerInfo?.fullName || '—'}</TableCell>
      <TableCell>{formatDate(file.lastModified)}</TableCell>
      {canDownload && (
        <TableCell>
          <Tooltip title="Download">
            <IconButton
              className={classes.downloadBtn}
              onClick={() => onDownloadFile(file)}
            >
              <SaveAltFilled />
            </IconButton>
          </Tooltip>
        </TableCell>
      )}
    </TableRow>
  )
}

export default SftpFileRow
